import React, { useState, useEffect } from "react";
import { Container, OverlayTrigger, Popover, FormCheck } from "react-bootstrap";
import { FaMobileAlt, FaAddressCard, FaEnvelope } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineRight } from "react-icons/ai";
import { useTranslation } from 'react-i18next';
import { TENANT_BUCKET, USER_VERIFICATION_DATA } from '../../common/constants'
import PageTitle from '../pageTitle/default.js';
import { useMiddletier } from "../../common/middletier";
import { useStoreDispatch, useStoreState, APP_STORE_ACTION } from '../../common/storeContext';
import "./template_01.css";




const MyProfile = (props) => {
    const appDispatch = useStoreDispatch()
    const appState = useStoreState()
    const navigate = useNavigate();
    const { mobileTitleToggle } = props;
    const { mutation, queries } = useMiddletier();
    const [memberGroupImage, setMemberGroupImage] = useState('');
    const { t } = useTranslation();

    const onSubmitLogout = () => {
        mutation([
          {
            method: 'logout',
            params: [],
            attributes: []
          }
        ])
          .then(({ data }) => {
            appDispatch({ type: APP_STORE_ACTION.LOGOUT })
            navigate('/')
          })
          .catch((error) => {
            console.error('error: ', error)
            appDispatch({ type: APP_STORE_ACTION.LOGOUT })
            navigate('/')
          })
      }

      
    // AUTO TRANSFER
    const onChangeAutoTransfer = () => {

        const currentAutoTransfer = !appState.user?.auto_restore
        // console.log('currentAutoTransfer: ', currentAutoTransfer)
        const method = 'changeAutoRestoreByMember'

        mutation([{
            method,
            params: [
                { code: 'autoRestore', graphqlType: 'Boolean', required: true, value: currentAutoTransfer },
            ],
            attributes: []

        }]).then(({ data }) => {
            appDispatch({ type: APP_STORE_ACTION.AUTO_TRANSFER, payload: currentAutoTransfer })

            if (currentAutoTransfer) {
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: t('auto_transfer_on'), typeAlert: 'info', title: t('main_wallet_auto_transfer') }
                });
            } else {
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: t('auto_transfer_off'), typeAlert: 'info', title: t('main_wallet_auto_transfer') }
                });
            }


        }).catch((error) => {
            console.log('error: ', error)
        })
    }

    useEffect(() => {
        // const method = 'member_bank_accounts'
        // console.log('appState.user.member_group', appState.user.member_group)

        queries([{
            method: 'member_group',
            params: [
                { code: 'id', graphqlType: 'String', required: true, value: appState.user?.member_group ?? '' },
            ],
            attributes: [['_logo', ['url']]]

        }]).then(({ data }) => {

            setMemberGroupImage(data['member_group']?._logo ? data['member_group']?._logo.url : `${TENANT_BUCKET}/icon/wallet_user.png`)

        }).catch((error) => {
            console.log('error: ', error)
            if (error?.networkError?.statusCode === 401) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
            } else {
                appDispatch({
                    type: APP_STORE_ACTION.SHOW_ALERT,
                    payload: { description: error.message.toString(), typeAlert: 'error' }
                });
            }
        })

    }, [appState.user, queries, navigate, appDispatch]);

    const formatAmount = (amount, decimalPoint) => {
        const factor = Math.pow(10, 0);
        const truncatedAmount = Math.floor(amount * factor) / factor;
        const formattedAmount = truncatedAmount.toLocaleString(appState.currencyFormat?.locale, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        return formattedAmount;
    }

    return (
        <>
            <section id="profileMobile_01">
                <div className="myProfile_body">
                    <PageTitle mobileToggle={mobileTitleToggle} title={"My Profile"} onlyBackButton={true} id={"myProfile_title"} />
                    <Container className="myProfile_container">
                        <section className="myProfile_info">
                            <div className="myProfile_info_user">
                                {memberGroupImage !== '' && (<img src={`${memberGroupImage}`} alt={'wallet user'} />)}
                                <label>{formatAmount(appState.user?.reward_points ?? 0, appState.currencyFormat.decimal_point)} <span className="point_name">{t('point')}</span></label>
                            </div>
                            {/* <div className="myProfile_info_reward">
                                <div className="color_primary myProfile_info_token">
                                    <img src={`${TENANT_BUCKET}/icon/token.png`} alt={'token'} />
                                    <label>2568 Tokens</label>
                                </div>
                                <div className="color_primary myProfile_info_point">
                                    <img src={`${TENANT_BUCKET}/icon/point.png`} alt={'point'} />
                                    <label>2568 Points</label>
                                </div>
                            </div> */}
                        </section>
                        {/* <section className="myProfile_mySetting">
                            <div className="subTitle myProfile_subTitle">{t('my_setting')}</div>
                            <div className="color_primary myProfile_mySetting_row">
                                <label>{t('user_verification')}</label>
                                <div className="d-flex align-items-center">
                                    {USER_VERIFICATION_DATA.map(function (item, index) {
                                        const _item = appState?.user?.[item.id]
                                        return (
                                            <div key={item.id}>
                                                <OverlayTrigger
                                                    trigger="click"
                                                    key={'bottom'}
                                                    placement={'bottom'}
                                                    overlay={
                                                        <Popover>
                                                            <Popover.Body>
                                                                {_item ? (t(`${item.name}_verifed_content`)) : (t(`${item.name}_unverifed_content`))}
                                                            </Popover.Body>
                                                        </Popover>
                                                    }
                                                >
                                                    <div className={`verify_icon ${_item ? 'validated' : ''}`}>
                                                        {item.name === 'phone_number' ? <FaMobileAlt /> : (item.name === 'email' ? <FaEnvelope /> : (item.name === 'dob' ? <FaAddressCard /> : <></>))}
                                                    </div>
                                                </OverlayTrigger>

                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="color_primary myProfile_mySetting_row">
                                <label>{t('auto_transfer')}</label>
                                <div>
                                    <FormCheck custom type="switch">
                                        <FormCheck.Input isInvalid checked={appState.user?.auto_restore} onClick={() => onChangeAutoTransfer()} />
                                    </FormCheck>
                                </div>
                            </div>
                        </section> */}
                        <section className="myProfile_myAccount">
                            <div className="subTitle myProfile_subTitle">{t('my_account')}</div>
                            <Link to="/my_account/user_info" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_userInfo.png`} alt={'user info'} />
                                    <label>{t('user_info')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            <Link to="/my_account/order_history" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_orderHistory.png`} alt={'order history'} />
                                    <label>{t('order_history')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            {/* <Link to="/wallet/change_game_password" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_changeGamePassword.png`} alt={'change game password'} />
                                    <label>{t('change_game_password')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link> */}
                            {/* <Link to="/wallet/banking_details" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_bankingDetails.png`} alt={'banking details'} />
                                    <label>{t('banking_details')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link> */}

                            <button className="font_button color_button myProfile_btnLogout" onClick={onSubmitLogout}>
                                {t('logout')}
                            </button>
                        </section>
                    </Container>
                </div>
            </section>

        </>

    );




};






export default MyProfile;
